import clsx from 'clsx'
import type { RepoData, WorkflowData, WorkflowRunConclusion } from '../types'
import { StatusIcon, statusRowClassName } from './utils/workflow-status'
import { timeSinceRunFinishedInBranch } from './utils/workflow-utils'

type Props = {
  repo: RepoData
}

export function RepoCard({ repo }: Props) {
  const workflows = Object.values(repo.workflows)

  return (
    <li
      className={clsx('border', 'rounded overflow-hidden', 'shadow-sm', 'w-96')}
    >
      <div
        className={clsx(
          'pl-5 p-4',
          'flex items-center justify-between',
          'border-b',
          'bg-neutral-100',
        )}
      >
        <a
          className="text-lg font-mono text-blue-800 hover:bg-blue-100"
          href={repo.html_url}
          target="_blank"
          rel="noreferrer"
        >
          {repo.name}
        </a>
      </div>
      <div className={clsx('divide-y', 'bg-neutral-50', 'text-neutral-500')}>
        {workflows
          .toSorted((workflow1) =>
            workflow1.latestRun?.conclusion === 'failure' ? -1 : 1,
          )
          .map((wf) => (
            <Workflow repo={repo.name} key={wf.name} workflow={wf} />
          ))}
      </div>
    </li>
  )
}

function Workflow(props: { repo: string; workflow: WorkflowData }) {
  const { workflow } = props
  const latestRun = workflow.latestRun
  const conclusion = latestRun?.conclusion as WorkflowRunConclusion

  return (
    <div
      className={clsx('px-4 py-1', 'flex justify-between items-center gap-2', statusRowClassName(conclusion))}
    >
      <a
        className="text-sm hover:bg-blue-100"
        href={workflow.html_url}
        target="_blank"
        rel="noreferrer"
      >
        {props.workflow.name}
      </a>
      <a
        href={latestRun?.html_url}
        target="_blank"
        rel="noreferrer"
        className={clsx(
          'flex items-center gap-1',
          latestRun?.html_url && 'hover:bg-blue-100',
        )}
      >
        <span className="text-xs uppercase">
          {latestRun ? timeSinceRunFinishedInBranch(latestRun) : 'No runs'}
        </span>
        <StatusIcon conclusion={conclusion} />
      </a>
    </div>
  )
}
